<template>
  <div class="relative">
      <div class="vx-navbar-wrapper" :class="classObj">
        <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
          <!-- SM - OPEN SIDEBAR BUTTON -->
          <vs-icon class="sm:inline-flex cursor-pointer p-2" icon-pack="speakol" icon="speakol-menu" @click.stop="showSidebar" />
          <vs-spacer />
          <CreateCampaign v-if="$can('create_campaigns')"/>

          <div class="help-center-dropdown">
            <vx-tooltip id="header-help-button" text="Help" position="right">
              <vs-dropdown vs-custom-content vs-trigger-click class="relative cursor-pointer">
                <div class="speakol-help-center-icon cursor-pointer">
                  <vs-icon icon="speakol-help" icon-pack="speakol"></vs-icon>
                </div>
                <vs-dropdown-menu class="help-parent vx-navbar-dropdown fixed">
                  <ul>
                    <li @click="$gtag.event('Help_Center')" id="header-help-center" class="dropdown-action-on-hover flex py-2 px-4 cursor-pointer">
                      <a class="help-options" href="https://speakol.zendesk.com/hc/en-us" target="_blank">
                        <span>Help Center</span>
                      </a>
                    </li>

                    <li id="header-contact-us" class="dropdown-action-on-hover flex py-2 px-4 cursor-pointer" @click="$gtag.event('Contact_us')">
                      <a class="help-options" href="https://speakol.zendesk.com/hc/en-us/requests/new" target="_blank">
                        <span>Contact Us</span>
                      </a>
                    </li>
                  </ul>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vx-tooltip>
          </div>

          <Notifications/>

          <profile-drop-down v-if="activeUserInfo" :activeUserInfo="activeUserInfo" />
        </vs-navbar>
      </div>
  </div>
</template>
<script>
import I18n                 from './components/I18n.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import NotificationDropDown      from './components/NotificationDropDown.vue'
import CreateCampaign      from './components/CreateCampaign.vue'
import Notifications from './components/Notifications.vue'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    CreateCampaign,
    NotificationDropDown,
    I18n,
    ProfileDropDown,
    Notifications
  },
  computed: {
    activeUserInfo () {
      return this.$store.getters['authentication/user']
    },
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  methods: {
    showSidebar() {
      if (this.windowWidth >= 1200) {
        this.$store.commit('TOGGLE_REDUCE_BUTTON', !this.$store.state.reduceButton)
      }
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }
}
</script>

<style lang="scss" scoped>
  .speakol-help-center-icon {
    border: 2px solid var(--metalicGray);
    border-radius: 100%;
    width: 20px;
    height: 20px;

    i {
      position: relative;
      top: 1px;
      left: 0.4px;
      color: var(--metalicGray);
      font-size: 13px !important;
    }
  }

  .help-parent {
    top: 84px !important;
  }

  .help-options {
    color: #2c2c2c;
  }

  .dropdown-action-on-hover:hover {
    background-color: #0092d7;
  }

  .dropdown-action-on-hover:hover .help-options {
    color: white;
  }

  .con-vs-dropdown--menu {
    transform: translate(-93%) !important;
  }

  @media screen and (max-width: 768px) {
    .con-vs-dropdown--menu {
      width: max-content;
    }
  }
</style>
